import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
export function ToastBridge() {
  const { i18n } = useTranslation();
  return <Toaster position={i18n.dir() === 'rtl' ? 'top-left' : 'top-right'} toastOptions={{ duration: 4000, style: { direction: i18n.dir(), background: 'var(--color-surface-raised)', color: 'var(--color-text)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-md)', fontFamily: 'var(--font-family)' } }} />;
}
